import appModule, { AppState } from '@/store/modules/app'
import layoutModule, { LayoutState } from '@/store/modules/layout'
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export interface RootState {
  app: AppState
  layout: LayoutState

  [key: string]: any
}

export default new Vuex.Store<RootState>({
  modules: {
    app: appModule,
    layout: layoutModule
  },
  plugins: [
    createPersistedState(
      { paths: ['app.currentUser'] }
    )
  ]
})
